import { apiCallProtected } from "../../api/axios";

/** Export PDF API call - raw response */
export const exportPDFRaw = async (url: string, body: Object = {}) => {
  console.log("[exportPDFRaw] URL:", url);
  console.log("[exportPDFRaw] Body:", body);

  return new Promise<Uint8Array>((resolve, reject) => {
    apiCallProtected
      .post(url, body, { responseType: "arraybuffer" }) // <- important!
      .then((res: any) => {
        console.log("[exportPDFRaw] Response received:", res);
        if (res) {
          const byteArray = new Uint8Array(res);
          resolve(byteArray);
        } else {
          reject("No PDF data received");
        }
      })
      .catch((err) => {
        console.error("[exportPDFRaw] API call failed:", err);
        reject(err?.message || err);
      });
  });
};

/** Utility to download the PDF */
export const downloadPDF = (byteArray: Uint8Array, filename: string) => {
  const blob = new Blob([byteArray], { type: "application/pdf" });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
